module.exports = __webpack_public_path__ + "static/media/01_360.34bf12db.jpeg";